export const events = {
  datevLaudsSettingsLogin: 'DATEV settings login clicked',
  datevLaudsSettingsLoginSuccessfully: 'DATEV settings login successfully',
  datevLaudsSettingsConsultantIDSelected: 'DATEV settings consultant id selected',
  datevLaudsSettingsClientIdMapped: 'DATEV settings client id mapped to factorial legal entity',
  datevLaudsSettingsBusinessUnitsMapped:
    'DATEV settings business units mapped to factorial employee groups',
  datevLaudsSettingsSalaryTypessMapped:
    'DATEV settings salary types mapped to Factorial compensation taoxonomies',
  datevLaudsSettingsDepartmentsMapped: 'DATEV settings departments mapped to Factorial teams',
  datevLaudsEmployeeCreated: 'DATEV new hire employee update synced successfully',
  datevLaudsEmployeeUpdated: 'DATEV personal or contract employee update synced successfully',
  datevLaudsEmployeeTerminated: 'DATEV employee terminated synced successfully',
  datevLaudsSettingsLeaveTypesMapped:
    'DATEV settings absence codes mapped to Factorial leave types',
  datevLaudsAbsenceCreated: 'DATEV absence created successfully',
}
